const GameplayPlayBoardsCompetitionPage = () => {
  return <div>Hello world</div>;
};

export default GameplayPlayBoardsCompetitionPage;
